module.exports = __webpack_public_path__ + "static/media/3-1.294befc4.png";